import keyBy from 'lodash/keyBy';

import { useTranslation } from '@lyearn/i18n';
import { Stack, Typography } from '@lyearn/ui';

import ReviewIcon from '../../components/QuestionReview/ReviewIcon';
import { OptionsListItemTypeEnum } from '../../single-select/types';
import { QuestionReviewProps } from '../../types';
import { getFtbResponseType } from '../utils';
import AnswerMap from './AnswerMap';
import CorrectAnswers from './CorrectAnswers';

const QuestionReview: React.FC<QuestionReviewProps> = ({
  question,
  correctAnswers,
  questionAttempt,
}) => {
  const { t } = useTranslation();

  const blanks = question.ftbComponents.filter((component) => component.isBlank);
  const correctFtbAnswers = correctAnswers?.correctFTBAnswers;
  const ftbResponse = questionAttempt?.submission?.ftbResponse || [];
  const ftbResponseById = keyBy(ftbResponse, 'blankId');
  const correctAnswerCount = blanks.filter(
    (blank) =>
      getFtbResponseType({ ftbComponent: blank, correctFtbAnswers, ftbResponse }) ===
      OptionsListItemTypeEnum.Correct,
  ).length;
  const isSubmitted = Boolean(questionAttempt?.isSubmitted);
  const showCorrectAnswers =
    isSubmitted && correctFtbAnswers && blanks.length !== correctAnswerCount;

  return (
    <>
      {ftbResponse.length ? (
        blanks.map((ftbComponent, index) => {
          const type = getFtbResponseType({ ftbComponent, correctFtbAnswers, ftbResponse });
          const response = ftbResponseById[ftbComponent.id];

          return (
            <Stack key={ftbComponent.id} className="px-8" gapX={12}>
              {isSubmitted ? <ReviewIcon type={type} /> : null}
              <AnswerMap
                labelLeft={t('QuizPlayer:BlankIndex', { index: index + 1 })}
                labelRight={response?.text}
              />
              {isSubmitted && type === OptionsListItemTypeEnum.Missed ? (
                <Typography color="text-text-success" variant="body-short-02">
                  {t('QuizPlayer:Missed')}
                </Typography>
              ) : null}
            </Stack>
          );
        })
      ) : (
        <Typography className="ms-8" color="text-text-placeholder" variant="label-02">
          {t('QuizPlayer:NotAnswered')}
        </Typography>
      )}
      {showCorrectAnswers ? (
        <CorrectAnswers correctFtbAnswers={correctFtbAnswers} ftbComponents={blanks} />
      ) : null}
    </>
  );
};

export default QuestionReview;
